import { apiSlice } from "@/shared/api/api-slice"

interface PurchaseRequest {
  user_id: number
  chat_id: number
  stars: number
  rating: number
  InitData: string
  is_group_purchase?: boolean
}

interface PurchaseResponse {
  paymentUrl: string
  paymentId: string
}

interface PaymentStatusResponse {
  status: "success" | "pending" | "failed"
}

export const purchaseApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["GroupRating"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      purchase: builder.mutation<PurchaseResponse, PurchaseRequest>({
        query: request => ({
          url: "/api/v1/purchase",
          method: "POST",
          body: request
        }),
        invalidatesTags: (_, error) => (error ? [] : ["Balance", "GroupRating"])
      }),

      checkPaymentStatus: builder.mutation<PaymentStatusResponse, string>({
        query: paymentId => ({
          url: `/api/v1/purchase/status?paymentId=${paymentId}`,
          method: "GET"
        }),
        invalidatesTags: (result, error) =>
          !error && result?.status === "success" ? ["Balance", "GroupRating", "Subscription"] : []
      })
    })
  })

export const { usePurchaseMutation, useCheckPaymentStatusMutation } = purchaseApi
